<template>
  <transition name="el-zoom-in-top">
    <div class="generalTip1" v-show="visible" role="status">
      <div class="generalTip" :class="positive ? 'generalTip_b' : 'generalTip_r'"><p>{{ message }}</p></div>
    </div>
  </transition>
</template>
<script>
export default { props: { visible: Boolean, positive: Boolean, message: String } };
</script>
<style lang="less" scoped>
.generalTip1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction:column;
  justify-content: center;
  align-items: center;
  z-index: 1009;

  .generalTip {
  position: fixed;
  padding: 0 60px;
  height: 60px;
  line-height: 60px;
  border-radius: 60px;
  top: 20px;
  color: #ffffff;
  font-size: 24px;
  text-align: center;
  }

  .generalTip_r {
  background: #ec4d3d;
  }

  .generalTip_b {
  background: #000;
}
}
</style>
